import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableId = 'tableBonusWins';
var formId = 'formBonusWins';
var btnCancelSearchId = 'btnCancelSearch';
var FILTER_DELIM = '-delim-';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-12't>r>" + "<'row'<''i><''p>>";

var COLUMNS_INDEX = {
    TicketId: 1,
    Bonus: 2,
    Player: 3,
    Customer: 4,
    CustomerOperation: 5,
    PlayerWinAmount: 6,
    MainWinAmount: 7,
    Level: 8,
    Created: 9,
    Started: 10,
    Finished: 11
}

export interface PendingHandpayWinsOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    urlCustomerDetail: string;
    urlPlayerDetail: string;
    urlBonusDetail: string;
    urlCustomerOperationDetail: string;
}

export class PendingHandpayWins extends PageBase<PendingHandpayWinsOptions> {
    private _tableOptions: DatatableOptions;
    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _filterTicketId: JQuery;
    private _filterPlayer: JQuery;
    private _filterBonus: MultiSelectApi;
    private _filterCustomer: MultiSelectApi;
    private _filterCustomerOperation: MultiSelectApi;
    private _table: Datatable;
    private _chckAllWins: JQuery;
    private _btnConfirm: JQuery;
    private _filterCreatedFrom: DateTimePickerApi;
    private _filterCreatedTo: DateTimePickerApi;

    constructor(options: PendingHandpayWinsOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);
        var getCustomerDetailUrl = (rowData: any): string => (`${options.urlCustomerDetail}/${rowData.CustomerId}`);
        var getPlayerDetailUrl = (rowData: any): string => (`${options.urlPlayerDetail}/${rowData.PlayerId}`);
        var getBonusDetailUrl = (rowData: any): string => (`${options.urlBonusDetail}/${rowData.BonusId}`);
        var getOperationDetailUrl = (rowData: any): string => (`${options.urlCustomerOperationDetail}/${rowData.CustomerOperationId}`);

        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.confirmWins = this.confirmWins.bind(this);

        window['setWinsSelectAllCheckbox'] = this.setWinsSelectAllCheckbox;

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',

            scrollX: false,
            //autoWidth: true,
            fixedHeader: false,
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input id='chckbx${rowData.Id}' name='selectedWin' value='${rowData.Id}' type='checkbox' onClick="setWinsSelectAllCheckbox()" />`);
                    }
                },
                {
                    data: "Id",
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'BonusName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkBonusDetail${rowData.Id}' href='${getBonusDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'PlayerRemoteId',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkPlayerDetail${rowData.Id}' href='${getPlayerDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'CustomerName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkCustomerDetail${rowData.Id}' href='${getCustomerDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'CustomerOperationName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkCustomerOperationDetail${rowData.Id}' href='${getOperationDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'PlayerWinAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='PlayerWinAmount${rowData.Id}'>${data} ${rowData.PlayerCurrency}</span>`)
                },
                {
                    data: 'MainWinAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='MainWinAmount${rowData.Id}'>${data} ${rowData.MainCurrency}</span>`)
                },
                { data: 'LevelCode' },
                {
                    data: 'Created',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='Created${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)},
                {
                    data: 'Started',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='Started${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)},
                {
                    data: 'Finished',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='Finished${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)},
                {
                    orderable: false,
                    data: 'filterButtons',
                    defaultContent: '',
                    searchable: false,
                    sortable: false
                }
            ],
            order: [[COLUMNS_INDEX.TicketId, "desc"]],
            callbacks: {
                //                createdRow: this.createdRow,
                preDrawCallback: this.preDrawCallback
            }//,
            //            rowDetail: {
            //                hasDetail: true,
            //                render: this.renderDetailRow
            //            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById(formId);
        this._btnCancelSearch = Utils.getJQueryById(btnCancelSearchId);
        this._filterTicketId = Utils.getJQueryById('filterGameRoundId');
        this._filterPlayer = Utils.getJQueryById('filterPlayer');
        this._filterBonus = new MultiSelectApi('filterBonus');
        this._filterCustomer = new MultiSelectApi('filterCustomer');
        this._filterCustomerOperation = new MultiSelectApi('filterCustomerOperation');
        this._filterCreatedFrom = new DateTimePickerApi('filterCreatedFrom');
        this._filterCreatedTo = new DateTimePickerApi('filterCreatedTo');
        this._chckAllWins = Utils.getJQueryById("winSelectAll");
        this._chckAllWins.on("change", this.checkBoxAll);
        this._btnConfirm = Utils.getJQueryById("btnConfirm");
        this._btnConfirm.on("click", this.confirmWins);

        this._table = new Datatable(tableId, this._tableOptions);

        // == attach to events
        // filter form submit -> redraw table
        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterBonus.selectAll();
        this._filterCustomer.selectAll();
        this._filterCustomerOperation.selectAll();
        this._filterTicketId.val('');
        this._filterPlayer.val('');
        this._filterCreatedFrom.clearDates();
        this._filterCreatedTo.clearDates();
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterTicketId = this._filterTicketId.val();
        datatable.columns(COLUMNS_INDEX.TicketId).search(filterTicketId);

        var filterPlayer = this._filterPlayer.val();
        datatable.columns(COLUMNS_INDEX.Player).search(filterPlayer);

        var filterBonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Bonus).search(filterBonus);

        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);

        var filterCustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.CustomerOperation).search(filterCustomerOperation);

        var filterCreatedFrom = this._filterCreatedFrom.getUnixTimestamp();
        var filterCreatedTo = this._filterCreatedTo.getUTCDate();
        var filterCreated = filterCreatedFrom + FILTER_DELIM + filterCreatedTo;
        datatable.columns(COLUMNS_INDEX.Created).search(filterCreated);
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedWin']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllWins[0]).checked;
        }
    }

    private setWinsSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedWin']");
        let winSelectAll = Utils.getJQueryById("winSelectAll")[0];
        if (Utils.isNullOrUndefined(winSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>winSelectAll).checked = allCheckboxesChecked;
    }

    private confirmWins(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var ids = $("input[name='selectedWin']:checked").map(function () {
            return $(this).val();
        });
        var idsToConfirm = ids.get();
        if (!idsToConfirm || idsToConfirm.length === 0) {
            return;
        }
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { ids: idsToConfirm },
            success: function (data) {
                table.draw();
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/PendingHandpayWins.ts
 **/